import React from "react";
// import BannerSectionStyle7 from "../Section/BannerSection/BannerSectionStyle7";
import Section from "../Section";
// import AppointmentSection from "../Section/AppointmentSection";
// import BreadcrumbStyle2 from "../Breadcrumb/BreadcrumbStyle2";
// import AboutSectionStyle2 from "../Section/AboutSection/AboutSectionStyle2";
// import FeaturesSectionStyle3 from "../Section/FeaturesSection/FeaturesSectionStyle3";
import TeamSectionStyle3 from "../Section/TeamSection/TeamSectionStyle3";
import { pageTitle } from "../../helpers/PageTitle";
// import { Link } from "react-router-dom";
// import Breadcrumb from "../Breadcrumb";
// import WorkingProcess from "../Section/WorkingProcess";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import FaqSectionStyle3 from "../Section/FaqSection/FaqSectionStyle3";
import DoctorDetailsSection from "../Section/DoctorDetailsSection";
import Spacing from "../Spacing";
import { Helmet } from "react-helmet";



export default function MercurySlush() {
  pageTitle("MercuryMini Details");
  return (
    <>
      <Helmet>
        <title>Mercury Slush – Surgical Slush Machine for Organ & Tissue Transplant | Manufacturer & Supplier | Mercuryhc Pvt Ltd

        </title>

        <meta name="Keyword" content="Heater cooler machine, Heater cooler unit, Hyper-Hypothermia, Hyper-Hypothermia unit, Hyper-Hypothermia Machine Manufacture, Heater Cooler Machine, Fast Cooling machine, Fast Cooling, Hypothermia Machine" />
        <meta name="description" content="Mercury Slush ensures rapid cooling for organ and tissue transplants. Features a 5L open tank, auto-stir, silent operation, and minimizes trauma to delicate tissues." />
        {/* Google Tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>

      </Helmet>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <div className="cs_doctor_details">
          <div
            className="cs_doctor_details_bg cs_bg_filed"

          />
          <Spacing md="85" />
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
                  <img src='/images/doctors/Mercury Slush.jpg' alt="Doctor" className="w-100 cs_radius_20 " />
                  <h3 className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24" style={{
                    padding: "14px 15px"
                  }}>
                    Mercury Slush
                  </h3>
                </div>



              </div>
              <div className="col-lg-6   position-relative">
                <Spacing md="55" />
                <h1 className="cs_fs_120 mb-0 cs_semibold" style={{
                  fontSize: "45px",
                  color: "#3f48cc"
                }}> Mercury Slush  </h1>

                <Spacing md="32" />
                <p className="mb-0 cs_heading_color"> Mercury slush produces slush like velvet to protect and preserve tissue and organ during
                  tissue and organ transplant surgeries. This improves valuable surgery time and patient
                  safety.
                  The use of slush improves rapid cooling of tissue and organs. </p>

                <Spacing md="32" />
                <h4 className="underline"> Applications</h4>
                <p style={{
                  color: "#274760"
                }}> The Mercury slush can be used for the surgeries like tissue transplant surgeries, organ
                  transplant surgeries.</p>


              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>

        <div className="container">

          <div className="img-details-container">
            {/* Left Section: Features and Product Images */}
            <div className="left-section">
              {/* Title */}
              {/* <h2>{item.tittle}</h2> */}

              {/* Features List */}
              <div className="featureList">
                <h3 className="underline" style={{
                  color: "#3f48cc"
                }}> Features</h3>
                <div className="listdata">
                  <ul>

                    <li   >
                      <strong>   Open Tank:</strong>  It has 5 Liter bowl capacity.
                    </li>
                    <li  >
                      <strong>  Minimize the risk of Trauma to delicate tissues and organs</strong>
                    </li>
                    <li  >
                      <strong>  Saves valuable time during surgeries  </strong>
                    </li>
                    <li  >
                      <strong>  Easy to operate and maintain  </strong>
                    </li>
                    <li  >
                      <strong>  Slush basin with auto-stir </strong>
                    </li>
                    <li  >
                      <strong>   Silent operation </strong>
                    </li>


                  </ul>
                </div>
              </div>

              {/* Product Images */}
              {/* <div className="Bottomside">

                <img src="/images/departments/Mercury Magma.jpg" />
                <img src="/images/departments/Mercury Magma.jpg" />
                <img src="/images/departments/Mercury Magma.jpg" />
                <img src="/images/departments/Mercury Magma.jpg" />
                <img src="/images/departments/Mercury Magma.jpg" />



              </div> */}
            </div>

            {/* Right Section: Side Images */}
            {/* <div className="rightside">


              <img src="/images/departments/Mercury Magma.jpg" />
              <img src="/images/departments/Mercury Magma.jpg" />
              <img src="/images/departments/Mercury Magma.jpg" />

            </div> */}
          </div>

        </div>


      </Section>

      <Section topMd={170} topLg={145} topXl={10} bottomLg={90}>

        <div className="container">
          <h3 className="underline">Specifications</h3>
          <div className="specification">

            <div className="leftside-specification">

              <div  >
                <h4>Dimensions:</h4>
                <ul>

                  <li  > Height: 35.5” (90.5 cm)  </li>
                  <li  > Width: 17.75” (45 cm)   </li>
                  <li  > Depth: 22.5” (57 cm)  </li>
                  <li  > Weight: 143 Lbs. (65 kg) </li>

                </ul>

              </div>
              <div  >
                <h4> Power Supply: </h4>
                <ul>

                  <li  > Voltage: 220 VAC, 1 Phase </li>
                  <li  > Frequency: 50Hz  </li>
                  <li  > Current: 15A   </li>
                  <li  > Leakage Current: 500MA Max  </li>

                </ul>

              </div>
            </div>
            <div className="rightside-specification">

              <div >
                <h4> Water Tank: </h4>
                <ul>

                  <li>Capacity: 5 Liter (1.32 Gal), Single tank </li>



                </ul>
              </div>

              <div >
                <h4> Compressor</h4>
                <ul>

                  <li>
                    Capacity: 1.5 Ton  </li>



                </ul>
              </div>
              <div >
                <h4>Output Ports: </h4>
                <ul>

                  <li>
                    Patient 1: Quick Connect, 5 Ltr/min     </li>




                </ul>
              </div>

            </div>
          </div>


          <Spacing md="32" />
        </div>
      </Section>
    </>
  );
}
